interface BooleanAttributeParams {
  key: string
  routeAttributes?: Record<string, boolean | string>
}

export const getBooleanRouteAttribute = ({ routeAttributes, key }: BooleanAttributeParams): boolean | undefined =>
  typeof routeAttributes?.[key] === 'boolean' ? routeAttributes[key] : undefined
